import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox } from '@cleartrip/bento'
import ModalHeader from '../UserProfileModalHeader'

import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'
import OtpBox from './otpBox'
import { checkForLinkingNudge, verifyOtpForSignIn, sendOtpForSignIn } from 'api/flights/results'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'
import { resolveKeysInObjectsArrays, isEmpty } from 'utils/browserHelper'
import { errorConfig } from './errorConfig'
const verifyEmail = ({
    toggle,
    email,
    setPageName,
    checkboxClass,
    rememberCheckedStatus,
    setRememberCheckedStatus,
    checkBoxTextClass,
    toggleModalAndClosePage,
    showCloseButton
}) => {
    const animationDefaultState = { isAnimate: false, direction: 'right', isFadeIn: false }

    const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]

    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
    const [otpValidationError, setOtpValidationError] = useState('')
    const [apiError, setApiError] = useState('')
    const [countDown, setCountDown] = useState(30)
    const [retriesLeft, setRetriesLeft] = useState(4)
    const [animationParams, setAnimationParams] = useState(animationDefaultState)
    const [isLoading, setIsLoading] = useState(false)
    const [elementInFocus, setElemntInFocus] = useState(0)

    const animatedClass = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'px-8': 'px-8'
    })
    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]
    const getOtpValue = () => {
        const otp = otpDigits.join('')
        return otp
    }

    let errorInfo = 'fs-inherit c-inherit pl-2'
    const disabled = getOtpValue().length != 6

    useEffect(() => {
        refs[0]?.current?.focus()
        countDownHandler(30)
    }, [])

    const transformEmail = email => {
        const [userName, domain] = email.split('@')
        let censoredUsername = ''
        if (userName.length > 5) {
            censoredUsername = userName[0] + userName[1] + '*'.repeat(userName.length - 4) + userName.slice(-2)
        } else {
            switch (userName.length) {
                case 1:
                    censoredUsername = '*'
                    break
                case 2:
                    censoredUsername = userName[0] + '*'
                    break
                case 3:
                    censoredUsername = userName[0] + '*' + userName[2]
                    break
                case 4:
                    censoredUsername = userName[0] + '*'.repeat(2) + userName[3]
                    break
                case 5:
                    censoredUsername = userName[0] + '*'.repeat(3) + userName[4]
                    break
            }
        }
        return censoredUsername + '@' + domain
    }
    const setElementInFocus = index => {
        setElemntInFocus(index)
        refs[index]?.current?.focus()
    }

    const countDownHandler = (countDown, lastCountdown = false) => {
        if (countDown === 0) {
            return
        } else {
            if (countDown === 1) {
                if (lastCountdown) {
                    setRetriesLeft(-1)
                }
            }
            const updatedCountDown = countDown - 1
            setCountDown(updatedCountDown)
            setTimeout(() => countDownHandler(updatedCountDown, lastCountdown), 1000)
        }
    }

    const clearOtp = () => {
        const emptyOtpDigits = ['', '', '', '', '', '']
        setOtpDigits(emptyOtpDigits)
        refs[0]?.current?.focus()
    }

    const resendOtp = async () => {
        // send otp logic
        //set retries = -1 if limit exceed
        setApiError('')
        if (countDown !== 0 || retriesLeft <= 0) {
            return
        } else {
            try {
                const payload = {
                    type: 'EMAIL',
                    value: email,
                    action: 'SIGNUP_MERGE'
                }
                const response = await sendOtpForSignIn(payload)
                const { status, data, error } = response || {}
                if (status === 202) {
                    const { action } = data || {}
                    clearOtp()
                    countDownHandler(30)
                } else {
                    const { response = { data: {} } } = error || {}
                    const { data = {} } = response
                    const { message } = data
                    const err = errorConfig[message] || errorConfig.default
                    setApiError(err)
                    if (message === 'OTP_SEND_LIMIT_EXCEEDED') {
                        setRetriesLeft(-1)
                    }
                }
            } catch (e) {
                console.log('Resend api error', e)
            }
        }
    }
    const otpChangeHandler = (event, index) => {
        const value = event.nativeEvent.data || event.target.value
        const numberValue = Number(value)
        if (value === ' ') return
        if (value === '') {
            const otpFieldValues = [...otpDigits]
            otpFieldValues[index] = ''
            setOtpDigits(otpFieldValues)
            return
        }
        if (numberValue >= 0 && Number.isInteger(numberValue)) {
            const otpFieldValues = [...otpDigits]
            otpFieldValues[index] = value % 10
            setOtpDigits(otpFieldValues)
            setElementInFocus(index + 1)
            return
        }
    }
    const otpCursorHandler = (event, index) => {
        if (event.keyCode === 37) {
            setElementInFocus(index - 1)
        }
        if (event.keyCode === 39) {
            setElementInFocus(index + 1)
        }
        if (event.keyCode === 8) {
            if (event.target.value === '') {
                const otpFieldValues = [...otpDigits]
                const indexToRemove = index - 1
                if (indexToRemove < 0) {
                    return
                }
                otpFieldValues[indexToRemove] = ''
                setOtpDigits(otpFieldValues)
                setElementInFocus(indexToRemove)
            } else {
                const otpFieldValues = [...otpDigits]
                otpFieldValues[index] = ''
                setOtpDigits(otpFieldValues)
            }
        }
    }
    const otpBlock = [1, 2, 3, 4, 5, 6].map((element, index) => {
        return (
            <OtpBox
                key={index}
                onKeyDown={e => otpCursorHandler(e, index)}
                onChange={e => otpChangeHandler(e, index)}
                onMouseDownCapture={() => {
                    setElementInFocus(index)
                }}
                ref={refs[index]}
                value={otpDigits[index]}
                style={{
                    margin: `11px ${index === 5 ? '0px' : '10px'} 14px 0px`,
                    border: otpValidationError
                        ? ' solid 1px #ff3c2b'
                        : refs[index]?.current === document.activeElement
                        ? 'solid 1px #36c'
                        : 'solid 1px #e6e6e6'
                }}
            />
        )
    })

    const checkHiFiveFlow = () => {
        const retVal =
            pathname &&
            pathname.length > 2 &&
            pathname[1] === 'ref' &&
            !isEmpty(pathname[2]) &&
            pathname[2] != 'null' &&
            pathname[2] != 'undefined'
        return retVal
    }

    const isHiFiveFlow = checkHiFiveFlow()

    const submitOtp = async () => {
        dataLayerGA({ section: 'Login' }, 'login_verify_clicked')
        setIsLoading(true)
        const otp = getOtpValue()
        const payload = {
            type: 'EMAIL',
            value: email,
            countryCode: '',
            action: 'SIGNUP_MERGE',
            otp
        }
        const response = await verifyOtpForSignIn(payload)
        const { status, data, error } = response || {}
        if (status === 200) {
            // const { action } = data || {}
            // const res = await checkForLinkingNudge()
            // const { status: responseStatus, data: responseData } = res || {}
            // if (responseStatus === 200) {
            //     if (responseData.action) {
            //         setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
            //     } else {
            ClevertapEvent({
                actionName: 'Email_verified_successfully',
                actionType: 'Button',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath) || isHiFiveFlow
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',

                currentPage: pagePath
            })
            ClevertapEvent({
                action_name: 'email_added_message',
                action: 'signup',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath) || isHiFiveFlow
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',
                is_logged_in: 'yes'
            })
            // toggleModalAndClosePage()
            setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED_PERSONAL_DETAILS)
            //     }
            // } else {
            //     const { message } = responseData
            //     const error = errorConfig[message] || errorConfig.default
            //     setApiError(error)
            // }
        } else {
            const { response = { data: {} } } = error || {}
            const { data = {} } = response
            const { message } = data
            const err = errorConfig[message] || errorConfig.default
            if (message === 'INVALID_OTP') {
                ClevertapEvent({
                    actionName: 'invalid_otp_message',
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',
                    is_logged_in: 'yes',
                    action: 'signin'
                })
            }
            if (message === 'USER_ALREADY_EXISTS_FOR_EMAIL') {
                ClevertapEvent({
                    actionName: 'email_exists_message',
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',
                    is_logged_in: 'yes',
                    action: 'signin'
                })
            }
            setApiError(err)
        }
        setIsLoading(false)
    }

    return (
        <div
            className="bg-white br-4 br-4 o-hidden d-flex flex-column"
            style={{
                width: '400px',
                height: '468px'
            }}
        >
            <div
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        if (!disabled) {
                            submitOtp()
                        }
                    }
                }}
                className={`${animatedClass} d-flex flex-1 flex-column`}
            >
                <ModalHeader title={'Verify email address'} toggle={toggle} showCloseButton={showCloseButton} />
                <OfflineToast page="verify email address" />
                {apiError && (
                    <>
                        <div
                            style={{ marginBottom: '22px' }}
                            className="py-3 px-2 flex flex-middle bg-error-600 c-white fs-2 br-4"
                        >
                            <InfoIcon className="c-white" height={16} width={16} />
                            <span className={errorInfo}>{apiError}</span>
                        </div>
                    </>
                )}

                <div className="d-flex flex-column flex-between flex-1">
                    <div>
                        <div
                            className={`c-pointer flex flex-middle ${
                                isLoading ? 'c-neutral-200' : 'c-secondary-500'
                            } fs-3 fw-500`}
                        >
                            <div style={{ marginLeft: '-2px', marginTop: '2px' }}>
                                <ArrowLeft height={18} className="c-inherit" />
                            </div>
                            &nbsp;{' '}
                            <span
                                className="fs-2 fw-500"
                                onClick={() => {
                                    setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED)
                                }}
                            >
                                {'Back'}
                            </span>
                        </div>
                        <Spacer className="pt-6" />
                        <p className="fs-3 c-neutral-700">
                            <span className="fs-3 c-neutral-700"> {'Enter the OTP sent to '} </span>
                            <span className="fs-3 c-neutral-700 fw-600">{`${transformEmail(email)}`}</span>
                        </p>
                        <div className="d-flex">{otpBlock}</div>
                        {otpValidationError && (
                            <div className="c-error-500 mb-3" style={{ marginTop: '-8px' }}>
                                {otpValidationError}
                            </div>
                        )}
                        <div style={{ marginBottom: '29px' }}>
                            <span className="fs-2 c-neutral-700">{"Haven't received OTP?"}</span>
                            <span
                                onClick={resendOtp}
                                className={`fs-2 fw-500 ml-1 ${
                                    retriesLeft === -1
                                        ? 'c-neutral-200'
                                        : countDown !== 0
                                        ? `c-neutral-200`
                                        : isLoading
                                        ? 'c-neutral-200'
                                        : 'c-blue c-pointer'
                                }`}
                            >
                                {retriesLeft === -1 ? 'Resend' : countDown !== 0 ? `Resend (${countDown}s)` : 'Resend'}
                            </span>
                        </div>
                        <Checkbox
                            className={checkboxClass}
                            checked={rememberCheckedStatus}
                            onClick={() => setRememberCheckedStatus(!rememberCheckedStatus)}
                        >
                            <span className={checkBoxTextClass}>{'Keep me logged in'}</span>
                        </Checkbox>
                    </div>

                    <div>
                        <Button
                            disabled={disabled}
                            size="md"
                            type="secondary"
                            full
                            busy={isLoading}
                            onClick={submitOtp}
                        >
                            <span className={`${disabled ? 'c-grey-30' : ''} fs-3 fw-500`}>
                                {'Verify and continue'}
                            </span>
                        </Button>
                        <Spacer className="mb-8" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default verifyEmail
